<template>
    <div class="container-fluid">
        <div class="row" style="height: 100vh;">
            <div class="col-2 bg-light p-3" id="sidebar">
                <h3>Cerca un luogo:</h3>
                <input type="text" id="searchBox" placeholder="Cerca una via a Bari...">
                <button @click="zoomToAddress" type="button" class="btn btn-primary">Cerca</button>
                <button type="button" class="btn btn-success" @click="saveMap">Salva mappa</button>

                <hr>

                <h3>Anagrafica:</h3>
                <label for="residenza">Sei residente a Bari?</label>
                <select v-model="anagrafica.residenza" id="residenza" required>
                    <option value="">-- Seleziona --</option>
                    <option value="si">Sì</option>
                    <option value="no">No</option>
                </select><br/>

                <label for="sesso">Di che sesso sei?</label>
                <select v-model="anagrafica.sesso" id="sesso" required>
                    <option value="">-- Seleziona --</option>
                    <option value="maschio">Maschio</option>
                    <option value="femmina">Femmina</option>
                    <option value="altro">Altro</option>
                </select><br/>

                <label for="eta">Che età hai?</label>
                <input
                    v-model="anagrafica.eta"
                    type="number"
                    id="eta"
                    placeholder="Inserisci la tua età"
                    required
                /><br/>

                <label for="tempo_bari">Quanto tempo della tua giornata trascorri a Bari? (%)</label>
                <input
                    v-model="anagrafica.tempo_a_bari"
                    type="number"
                    id="tempo_bari"
                    min="0"
                    max="100"
                    placeholder="es. 60"
                    required
                />

                <hr>

                <h3>Seleziona una categoria:</h3>
                <h6 class="sociabilita">🔴 Sociabilità</h6>
                <select class="category" v-model="selectedSubcategory" @change="handleCategoryChange"
                        :data-type="'Sociabilità'">
                    <option value="">-- Seleziona una categoria --</option>
                    <option value="Bar">Bar</option>
                    <option value="Libreria">Libreria</option>
                    <option value="Biblioteca">Biblioteca</option>
                    <option value="McDonald's">McDonald's</option>
                    <option value="Piazza">Piazza</option>
                    <option value="Cortile scuola">Cortile scuola</option>
                    <option value="Spazio d'incontro per giovani">Spazio d'incontro per giovani</option>
                    <option value="Tennis">Tennis</option>
                    <option value="Campo (spazio per attività di gruppo)">Campo spazio per attività di gruppo</option>
                    <option value="Piscina">Piscina</option>
                    <option value="Palestra">Palestra</option>
                    <option value="Pista di pattinaggio">Pista di pattinaggio</option>
                    <option value="Giostre">Giostre</option>
                    <option value="Sala giochi">Sala giochi</option>
                    <option value="Marciapiedi">Marciapiedi</option>
                    <option value="Panchine semicircolari">Panchine semicircolari</option>
                    <option value="Panchina rossa per ricordare vittime di violenze">Panchina rossa per ricordare
                                                                                     vittime di
                                                                                     violenze
                    </option>
                    <option value="Terrazze">Terrazze</option>
                    <option value="Giardino">Giardino</option>
                    <option value="Area">Area</option>
                    <option value="Sosta">Sosta</option>
                    <option value="Attrezzi (da parco giochi)">Attrezzi da parco giochi</option>
                    <option value="Altalene">Altalene</option>
                    <option value="Tavolo da gioco">Tavolo da gioco</option>
                    <option value="Tiro con l'arco">Tiro con l'arco</option>
                    <option value="Gioco della campana">Gioco della campana</option>
                    <option value="Bagni pubblici">Bagni pubblici</option>
                    <option value="Chiesa">Chiesa</option>
                </select>

                <h6 class="usi-attivita">🟡 Usi e Attività</h6>
                <select class="category" v-model="selectedSubcategory" @change="handleCategoryChange"
                        :data-type="'Usi e Attività'">
                    <option value="">-- Seleziona una categoria --</option>
                    <option value="Palestra interna">Palestra interna</option>
                    <option value="Palestra scoperta">Palestra scoperta</option>
                    <option value="Campo da calcio">Campo da calcio</option>
                    <option value="Centro Sportivo">Centro Sportivo</option>
                    <option value="Circolo Tennis">Circolo Tennis</option>
                    <option value="Beach Volley">Beach Volley</option>
                    <option value="Pista per Motocross">Pista per Motocross</option>
                    <option value="Pista da Go Kart">Pista da Go Kart</option>
                    <option value="Parco delle Arti">Parco delle Arti</option>
                    <option value="Museo">Museo</option>
                    <option value="Teatro">Teatro</option>
                    <option value="Casa della musica">Casa della musica</option>
                    <option value="Cortile">Cortile</option>
                    <option value="Punto d'incontro">Punto d'incontro</option>
                    <option value="Area Pic-Nic">Area Pic-Nic</option>
                    <option value="Area yoga">Area yoga</option>
                    <option value="Percorso naturalistico">Percorso naturalistico</option>
                    <option value="Parcheggio">Parcheggio</option>
                    <option value="Fermata autobus">Fermata autobus</option>
                    <option value="Libreria">Libreria</option>
                    <option value="Cartoleria ed edicola">Cartoleria ed edicola</option>
                    <option value="Supermercato">Supermercato</option>
                    <option value="Mercato settimanale">Mercato settimanale</option>
                    <option value="Farmacia">Farmacia</option>
                    <option value="Macellaio">Macellaio</option>
                    <option value="Pizzeria">Pizzeria</option>
                    <option value="Barbiere">Barbiere</option>
                    <option value="Negozio di Fiori">Negozio di Fiori</option>
                    <option value="Guardia medica">Guardia medica</option>
                    <option value="Distributori H24">Distributori H24</option>
                    <option value="Posta">Posta</option>
                    <option value="Panificio">Panificio</option>
                    <option value="Chiesa">Chiesa</option>
                    <option value="Concattedrale">Concattedrale</option>
                    <option value="Ex Banca">Ex Banca</option>
                    <option value="Villa">Villa</option>
                </select>

                <h6 class="accessibilita">🔵 Accessibilità e Connessioni</h6>
                <select class="category" v-model="selectedSubcategory" @change="handleCategoryChange"
                        :data-type="'Accessibilità e Connessioni'">
                    <option value="">-- Seleziona una categoria --</option>
                    <option value="Semaforo rotto">Semaforo rotto</option>
                    <option value="Semaforo mezzo funzionante">Semaforo mezzo funzionante</option>
                    <option value="Segnaletica mancante">Segnaletica mancante</option>
                    <option value="Segnaletica danneggiata">Segnaletica danneggiata</option>
                    <option value="Mancanza di marciapiedi">Mancanza di marciapiedi</option>
                    <option value="Marciapiedi in cattivo stato">Marciapiedi in cattivo stato</option>
                    <option value="Ponte pedonale">Ponte pedonale</option>
                    <option value="Pista ciclabile inizio">Pista ciclabile inizio</option>
                    <option value="Pista ciclabile fine">Pista ciclabile fine</option>
                    <option value="Entrata secondaria">Entrata secondaria</option>
                    <option value="Entrata terziaria">Entrata terziaria</option>
                    <option value="Ingresso per le auto/scuolabus">Ingresso per le auto/scuolabus</option>
                    <option value="Ingresso pedonale">Ingresso pedonale</option>
                    <option value="Zona pericolosa">Zona pericolosa</option>
                    <option value="Zone pericolose per pedoni">Zone pericolose per pedoni</option>
                    <option value="Incrocio pericoloso">Incrocio pericoloso</option>
                    <option value="Pericolo specifico">Pericolo specifico</option>
                    <option value="Punto di debolezza">Punto di debolezza</option>
                    <option value="Spazio parcheggio">Spazio parcheggio</option>
                    <option value="Parcheggi">Parcheggi</option>
                    <option value="Fermata autobus/scuolabus">Fermata autobus/scuolabus</option>
                    <option value="Fermate autobus non sicure">Fermate autobus non sicure</option>
                    <option value="Auto in doppia fila">Auto in doppia fila</option>
                    <option value="Piazza Sylos">Piazza Sylos</option>
                </select>

                <h6 class="comfort">🟢 Comfort e Immagine</h6>
                <select class="category" v-model="selectedSubcategory" @change="handleCategoryChange"
                        :data-type="'Comfort e Immagine'">
                    <option value="">-- Seleziona una categoria --</option>
                    <option value="Frutteto">Frutteto</option>
                    <option value="Villa Comunale">Villa Comunale</option>
                    <option value="Parco comunale">Parco comunale</option>
                    <option value="Area verde">Area verde</option>
                    <option value="Mini bosco">Mini bosco</option>
                    <option value="Orto botanico per attività didattiche">Orto botanico per attività didattiche</option>
                    <option value="Aiuole">Aiuole</option>
                    <option value="Alberatura stradale">Alberatura stradale</option>
                    <option value="Giardino scolastico">Giardino scolastico</option>
                    <option value="Boschetto da recuperare">Boschetto da recuperare</option>
                    <option value="Parco yoga">Parco yoga</option>
                    <option value="Bosco fitto">Bosco fitto</option>
                    <option value="Manutenzione urbana">Manutenzione urbana</option>
                    <option value="Ponte ">Ponte</option>
                    <option value="Attività Bonificazione">Attività Bonificazione</option>
                    <option value="Distributore dell'acqua">Distributore dell'acqua</option>
                    <option value="Area con attrezzi">Area con attrezzi</option>
                    <option value="Piazzetta scuola">Piazzetta scuola</option>
                    <option value="Piazza">Piazza</option>
                    <option value="Parkour">Parkour</option>
                    <option value="Crimini">Crimini</option>
                    <option value="Omicidi">Omicidi</option>
                    <option value="Furti">Furti</option>
                    <option value="Rapine">Rapine</option>
                    <option value="Aggressioni">Aggressioni</option>
                    <option value="Incendi">Incendi</option>
                    <option value="Crimini per droghe">Crimini per droghe</option>
                    <option value="Sparatorie">Sparatorie</option>
                </select>
                <hr>
                <h3>Percorso casa-scuola:</h3>
                <button class="btn btn-primary" @click="enablePathDrawing">
                    Disegna tragitto
                </button>

                <button class="btn btn-success" @click="savePath">
                    Salva tragitto
                </button>

                <button class="btn btn-danger" @click="clearAllPaths">
                    Cancella tutti i tragitti
                </button>

            </div>

            <div class="col-10 p-0">
                <div id="map"></div>
            </div>

        </div>
    </div>

    <div id="transportPopup">
        <div class="popup-content">
            <h3>Seleziona il mezzo di trasporto</h3>
            <select id="transportSelect" style="width:100%; padding:8px; margin-bottom: 20px;">
                <option value="a piedi">A piedi</option>
                <option value="in auto">In auto</option>
                <option value="in bicicletta">In bicicletta</option>
                <option value="altro">Altro</option>
            </select>
            <button @click="confirmTransportSelection"
                    style="padding:8px; background:#007bff; color:white; border:none;">
                Conferma
            </button>
        </div>
    </div>

</template>

<script>
/* global google */
import {createApp, h} from "vue";
import {useHead} from "@vueuse/head";
import RatingInfoWindow from "@/components/RatingInfoWindow.vue";

export default {
    //components: {RatingInfoWindow},
    setup() {
        useHead({
            title: 'InfoNav - Human perception'
        });
    },
    data() {
        return {
            map: null,
            markers: [],
            markersObjects: [],
            selectedCategory: "",
            selectedSubcategory: "",
            allPaths: [],
            currentPathMarkers: [],
            currentPolylines: [],
            isDrawingMode: false,
            anagrafica: {
                residenza: '',
                sesso: '',
                eta: null,
                tempo_a_bari: null,
            },
            categories: {
                "Sociabilità": ["Comunità", "Amichevole", "Interattivo", "Accogliente", "Diversificato", "Curato", "Condiviso", "Motivo di vanto"],
                "Usi e Attività": ["Divertente", "Attivo", "Vitale", "Speciale", "Autentico", "Utile", "Originario", "Sostenibile", "Commemorativo"],
                "Accessibilità e Connessioni": ["Continuità", "Prossimità", "Connessione", "Leggibilità", "Pedonabilità", "Convenienza", "Accessibilità"],
                "Comfort e Immagine": ["Sicuro", "Pulito", "Verde", "Pedonabile", "Spazi di sosta", "Spirituale", "Gradevole e attrattivo", "Storico"]
            }
        }
    },
    methods: {
        zoomToAddress() {
            let address = document.getElementById("searchBox").value;
            if (!address) {
                alert("Inserisci una via da cercare.");
                return;
            }

            let geocoder = new google.maps.Geocoder();
            geocoder.geocode({'address': address + ', Bari, Italia', 'region': 'IT'}, (results, status) => {
                if (status === 'OK') {
                    this.map.setCenter(results[0].geometry.location);
                    this.map.setZoom(17);
                } else {
                    alert("Indirizzo non trovato: " + status);
                }
            });
        },
        addMarker(location, category) {
            let colors = {
                "Sociabilità": "red",
                "Usi e Attività": "yellow",
                "Accessibilità e Connessioni": "blue",
                "Comfort e Immagine": "green"
            };

            // let subcategory = $(".category").map(function () {
            //   return $(this).val() ? $(this).val() : null;
            // }).get().filter(Boolean)[0];

            const id = Date.now() + Math.random();

            let marker = new google.maps.Marker({
                id: id,
                position: location,
                map: this.map,
                title: `${category} - ${this.selectedSubcategory}`,
                draggable: true,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 10,
                    fillColor: colors[category] || "gray",
                    fillOpacity: 1,
                    strokeWeight: 1
                }
            });

            //let index = this.markers.length;
            this.markers.push({
                id: id,
                position: location.toJSON(),
                category: category,
                subcategory: this.selectedSubcategory,
                description: "",
                timeRange: ""
            });

            this.attachRatingForm(marker, id, category, this.selectedSubcategory);
        },
        deleteMarker(id) {
            const markerIndex = this.markersObjects.findIndex(m => m.id === id);
            if (markerIndex !== -1) {
                const marker = this.markersObjects[markerIndex];
                marker.infoWindow?.close?.();
                google.maps.event.clearInstanceListeners(marker); // <— add this
                marker.setMap(null);
                this.markersObjects.splice(markerIndex, 1);
            }

            const dataIndex = this.markers.findIndex(m => m.id === id);
            if (dataIndex !== -1) this.markers.splice(dataIndex, 1);

            console.log("Marker cancellato!");
        },
        saveDescription(id, text) {
            const index = this.markers.findIndex(m => m.id === id);
            this.markers[index].description = text;
        },
        saveTimeRange(id, range) {
            const index = this.markers.findIndex(m => m.id === id);
            this.markers[index].timeRange = range;
        },
        //   attachRatingForm(marker, index, category) {
        //       let ratings = this.getRatingsForCategory(category);
        //       let timeRangeSelect = `
        //     <label>Fascia oraria:</label>
        //     <select id="timeRange${index}" style="width:100%; padding:4px; margin-bottom:10px;">
        //       <option value="">-- Seleziona una fascia --</option>
        //       <option value="00:00-04:00">00:00-04:00</option>
        //       <option value="04:00-08:00">04:00-08:00</option>
        //       <option value="08:00-12:00">08:00-12:00</option>
        //       <option value="12:00-16:00">12:00-16:00</option>
        //       <option value="16:00-20:00">16:00-20:00</option>
        //       <option value="20:00-24:00">20:00-24:00</option>
        //     </select>
        // `;
        //
        //       let contentString = `
        //     <div class="rating">
        //         <p><strong>Categoria:</strong> ${category}</p>
        //         <textarea id="desc${index}" placeholder="Inserisci una descrizione spontanea..." rows="3" cols="30">
        //           ${this.markers[index].description || ''}
        //         </textarea>
        //         ${timeRangeSelect}
        //         ${ratings.map(label => this.generateStarRating(label, index)).join('')}
        //         <button class="btn btn-danger btn-sm" onclick="window.deleteMarker(${index})">Cancella Marker</button>
        //
        //     </div>
        // `;
        //
        //       let infoWindow = new google.maps.InfoWindow({
        //           content: contentString
        //       });
        //
        //       // Add listener when the InfoWindow is opened
        //       // this.$nextTick(() => {
        //       //   const selectElement = document.getElementById(`timeRange${index}`);
        //       //   if (selectElement) {
        //       //     console.log(index);
        //       //     selectElement.addEventListener("change", (event) => {
        //       //       this.saveTimeRange(index, event.target.value); // Vue method to save time range
        //       //     });
        //       //   }
        //       //
        //       //   const textarea = document.getElementById(`desc${index}`);
        //       //   if (textarea) {
        //       //     textarea.addEventListener("input", (event) => {
        //       //       this.saveDescription(index, event.target.value); // <-- Vue method
        //       //     });
        //       //   }
        //       // });
        //
        //       marker.addListener("click", () => {
        //           infoWindow.open(this.map, marker);
        //
        //           setTimeout(() => {
        //               const selectElement = document.getElementById(`timeRange${index}`);
        //               if (selectElement) {
        //                   selectElement.addEventListener("change", (event) => {
        //                       this.saveTimeRange(index, event.target.value);
        //                   });
        //               }
        //
        //               const textarea = document.getElementById(`desc${index}`);
        //               if (textarea) {
        //                   textarea.addEventListener("input", (event) => {
        //                       this.saveDescription(index, event.target.value.trim());
        //                   });
        //               }
        //
        //               this.getRatingsForCategory(category).forEach((label) => {
        //                   const complete_name = label + index;
        //                   document.querySelectorAll('input[name="' + complete_name + '"]').forEach((radio) => {
        //                       radio.addEventListener("change", (event) => {
        //                           this.saveRating(index, label, event.target.value);
        //                       });
        //                   });
        //               });
        //
        //           }, 50); // 0ms works, or use 50–100ms for safety
        //
        //       });
        //
        //       marker.descId = `desc${index}`;
        //   },
        attachRatingForm(marker, id, category, subcategory) {
            const markerDataIndex = this.markers.findIndex(m => m.id === id);
            const markerData = this.markers[markerDataIndex];
            // const markerObjIndex = this.markersObjects.findIndex(m => m.id === id);


            const rating_adj = this.categories[category];
            const container = document.createElement("div");
            const infoWindow = new google.maps.InfoWindow({content: container});

            const app = createApp({
                render: () =>
                    h(RatingInfoWindow, {
                        id: id,
                        category: category,
                        subcategory: subcategory,
                        rating_adj: rating_adj,
                        ratings: markerData?.ratings || {},
                        timeRange: markerData?.timeRange || "",
                        description: markerData?.description || "",
                        "onUpdate:rating": ({label, value}) => {
                            this.saveRating(id, label, value);
                        },
                        "onUpdate:description": (desc) => {
                            this.saveDescription(id, desc);
                        },
                        "onUpdate:timeRange": (tr) => {
                            this.saveTimeRange(id, tr);
                        },
                        onDelete: () => {
                            infoWindow.close();
                            app.unmount();
                            this.deleteMarker(id);
                        },
                    }),
            });

            app.mount(container);

            marker.addListener("click", () => {
                infoWindow.open(this.map, marker);
            });

            marker.infoWindow = infoWindow;

            marker.id = id;

            this.markersObjects.push(marker);

        },
        resetCategories() {
            // $(".category").val("");
            this.selectedSubcategory = "-- Seleziona una categoria --";
            this.selectedCategory = "";
        },
        async saveMap() {
            let mapData = {
                anagrafica: this.anagrafica,
                markers: this.markers.map(marker => ({
                    position: marker.position,
                    category: marker.category,
                    subcategory: marker.subcategory,
                    description: marker.description.trim() || "",
                    timeRange: marker.timeRange || "",
                    ratings: marker.ratings || {}
                })),
                paths: this.allPaths.map(path => ({
                    coordinates: path.markers.map(marker => marker.getPosition().toJSON()),
                    transport_mode: path.transport_mode
                }))
            };

            await fetch('/api/human_perception/report', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(mapData),
            }).then(response => {
                let data = response.json();
                if (response.ok) {
                    return data
                } else {
                    throw new Error("Errore nel salvataggio:", data);
                }
            })
                .then(() => {
                    alert("Mappa e tragitti salvati con successo!");
                }).catch(error => {
                    console.error("Errore nel salvataggio:", error);
                });
        },
        enablePathDrawing() {
            this.isDrawingMode = true;
            google.maps.event.clearListeners(this.map, 'click');
            this.map.addListener('click', (event) => {
                if (this.isDrawingMode) {
                    this.addPathMarker(event.latLng);
                }
            });
        },
        addPathMarker(location) {
            let marker = new google.maps.Marker({
                position: location,
                map: this.map,
                draggable: false,
                icon: {
                    path: google.maps.SymbolPath.CIRCLE,
                    scale: 8,
                    fillColor: this.getRandomColor(),
                    fillOpacity: 1,
                    strokeWeight: 1
                }
            });

            this.currentPathMarkers.push(marker);

            if (this.currentPathMarkers.length > 1) {
                this.drawPath();
            }
        },
        drawPath() {
            let pathCoords = this.currentPathMarkers.map(marker => marker.getPosition());
            let polyline = new google.maps.Polyline({
                path: pathCoords,
                geodesic: true,
                strokeColor: this.getRandomColor(),
                strokeOpacity: 1.0,
                strokeWeight: 3
            });
            polyline.setMap(this.map);
            this.currentPolylines.push(polyline);
        },
        savePath() {
            if (this.currentPathMarkers.length > 1) {
                this.openTransportPopup();
            } else {
                alert("Aggiungi almeno due punti per salvare un tragitto!");
            }
        },
        openTransportPopup() {
            document.getElementById("transportPopup").style.display = "block";
        },
        confirmTransportSelection() {
            let transportMode = document.getElementById("transportSelect").value;
            this.allPaths.push({
                markers: [...this.currentPathMarkers],
                polylines: [...this.currentPolylines],
                transport_mode: transportMode
            });
            this.currentPathMarkers = [];
            this.currentPolylines = [];
            this.isDrawingMode = false;
            this.resetDrawingMode();
            document.getElementById("transportPopup").style.display = "none";
            alert("Tragitto salvato con mezzo: " + transportMode);
        },
        resetDrawingMode() {
            this.isDrawingMode = false;
            google.maps.event.clearListeners(this.map, 'click');
            this.map.addListener("click", (event) => {
                if (this.selectedCategory) {
                    this.addMarker(event.latLng, this.selectedCategory);
                    this.resetCategories();
                }
            });
        },
        clearAllPaths() {
            this.allPaths.forEach(path => {
                path.markers.forEach(marker => marker.setMap(null));
                path.polylines.forEach(poly => poly.setMap(null));
            });
            this.allPaths = [];

        },
        getRandomColor() {
            let colors = ["#FF00FF", "#FF00FF"];
            return colors[Math.floor(Math.random() * colors.length)];
        },
        saveRating(id, label, value) {
            const index = this.markers.findIndex(m => m.id === id);
            if (!this.markers[index].ratings) {
                this.markers[index].ratings = {};
            }
            this.markers[index].ratings[label] = value;
        },
        handleCategoryChange(event) {
            const value = event.target.value;
            const type = event.target.dataset.type;

            this.selectedSubcategory = value !== "-- Seleziona una categoria --" ? value : "-- Seleziona una categoria --";
            this.selectedCategory = value !== "" ? type : "";
        },
    },
    mounted() {
        window.initMap = () => {
            this.mapStyle = [
                {elementType: "labels.icon", stylers: [{visibility: "off"}]},
                {elementType: "labels.text.fill", stylers: [{color: "#616161"}]},
                {elementType: "labels.text.stroke", stylers: [{color: "#f5f5f5"}]},
                {
                    featureType: "poi.business",
                    elementType: "labels.text",
                    stylers: [{visibility: "on"}]
                },
                {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [{color: "#e0e0e0"}]
                }
            ];

            this.map = new google.maps.Map(document.getElementById("map"), {
                center: {lat: 41.117143, lng: 16.871871},
                zoom: 13,
                styles: this.mapStyle
            });

            this.map.addListener("click", (event) => {
                if (this.selectedCategory) {
                    this.addMarker(event.latLng, this.selectedCategory);
                    this.resetCategories();
                }
            });

        };
    },
    computed: {
        subcategory() {
            return this.selectedSubcategory || null;
        }
    },
    watch: {
        // watch only IDs so we don't trigger on deep edits like description/ratings
        markers: {
            handler(newMarkers) {
                const idSet = new Set(newMarkers.map(m => m.id));
                // filter out any overlay whose id isn't in data anymore
                this.markersObjects = this.markersObjects.filter(marker => {
                    if (!idSet.has(marker.id)) {
                        marker.infoWindow?.close?.();
                        // clean listeners to avoid leaks
                        google.maps.event.clearInstanceListeners(marker);
                        marker.setMap(null);
                        return false; // drop it from the array
                    }
                    return true;
                });
            },
            deep: false, // important: we only care when the set of items changes
            immediate: true // also cleans up anything stale on mount

        }
    }
}

</script>

<style scoped>
body {
    /* display: flex; */
    font-family: Arial, sans-serif;
}

#sidebar {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

h6 {
    margin-top: 20px;
    margin-bottom: 5px;
    font-weight: bold;
}

h6.sociabilita {
    color: red;
}

h6.usi-attivita {
    color: gold;
}

h6.accessibilita {
    color: blue;
}

h6.comfort {
    color: green;
}

select {
    width: 100%;
    padding: 8px;
    font-size: 14px;
}

/*button {
//  margin-top: 20px;
//  padding: 8px;
//  background: #007bff;
//  color: white;
//  border: none;
//  cursor: pointer;
//}
//
//button:hover {
//  background: #0056b3;
//} */

#map {
    flex: 1;
    height: calc(100vh - 20px);
    min-height: 100vh;
}

.rating {
    display: flex;
    flex-direction: column;
}

.stars {
    display: flex;
    direction: rtl;
    unicode-bidi: bidi-override;
}

.stars input {
    display: none;
}

.stars label {
    font-size: 20px;
    cursor: pointer;
    color: #ccc;
}

.stars input:checked ~ label,
.stars label:hover,
.stars label:hover ~ label {
    color: gold;
}

/* Stili per il popup di selezione trasporto */
#transportPopup {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
}

#transportPopup .popup-content {
    position: relative;
    width: 300px;
    margin: 15% auto;
    padding: 20px;
    background: white;
    border-radius: 5px;
}

#searchBox {
    padding: 5px;
    margin-top: 10px;
}

/*#delete_marker {
//    margin-top:10px;
//    padding:5px;
//    background:#dc3545;
//    color:white;
//    border:none;
//    cursor:pointer;"
}*/

/*.route-buttons {
//  margin-top: 10px;
//  padding: 8px;
//  color: white;
//  border: none;
//  cursor: pointer;
//}
//
//#draw-route {
//  background: #28a745;
//}
//
//#save-route {
//  background: #007bff;
/}*/

</style>